import { Other } from '@/modules/Other';
import Repository from './client/TbsJsonAxiosClient';

const resource = '';
export const useOtherRepository = () => {
  /**
   * お問合せ先のJSONを取得する
   */
  const getFormUrl = async () => {
    const { data } = await Repository.get<Other>(`${resource}/common_setting.json`).catch((e) => {
      throw e;
    });
    return data;
  };
  return {
    getFormUrl,
  };
};
export type OtherRepository = ReturnType<typeof useOtherRepository>;
